/** Adım noktaları (müzakere ve kişi ekleme sihirbazlarıyla aynı). */
export default function StepDots({ count, index }) {
  return (
    <div className="flex justify-center gap-2 py-3" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          className={`h-2 rounded-full transition-all ${
            i === index
              ? "w-[22px] bg-terakkiPrimaryDark dark:bg-white"
              : i < index
                ? "w-2 bg-terakkiBrand dark:bg-terakkiBrandSoft"
                : "w-2 bg-terakkiBrandMist dark:bg-white/10"
          }`}
        />
      ))}
    </div>
  );
}
